<template>
  <PolicyEmbed
    title="Privacy Policy"
    subtitle="See how we keep your Spooky Merge adventure safe and secure."
    src="https://joy2ever-policy.com/spooky-merge/view#spooky-merge_privacy-policy"
  />
</template>

<script>
import PolicyEmbed from '@/components/PolicyEmbed';

export default {
  name: 'PrivacyPolicy',
  components: {
    PolicyEmbed,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/PrivacyPolicy.vue